








































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  DispInquiryAnswer,
  DEFAULT_INQUIRY_ANSWER,
  DispInquiry,
  DEFAULT_DISP_INQUIRY,
} from "@/model/inquiry";
import {
  ANSWER_STATUS,
  ANSWER_STATUS_COLOR,
  ANSWER_METHOD,
  INQUIRY_PUBLISHED,
  INQUIRY_PUBLISHED_COLOR,
  ANSWER_ASSIGN,
  INQUIRY_QUESTIONNAIRE,
} from "@/consts/inquiry";
import UtilMixin from "@/mixins/utilMixin";
import AnswerContent from "@/components/inquiry/answerContent.vue";
import AttachmentViewer from "@/components/admin_common/AttachmentViewer.vue";

@Component({
  components: {
    AnswerContent,
    AttachmentViewer,
  },
})
export default class AnswerInfo extends Mixins(UtilMixin) {
  @Prop({ default: DEFAULT_INQUIRY_ANSWER }) inquiryAnswer!: DispInquiryAnswer;
  @Prop({ default: () => ({ ...DEFAULT_DISP_INQUIRY }) }) inquiry!: DispInquiry;

  private ANSWER_STATUS = ANSWER_STATUS;
  private ANSWER_STATUS_COLOR = ANSWER_STATUS_COLOR;
  private ANSWER_METHOD = ANSWER_METHOD;
  private INQUIRY_QUESTIONNAIRE = INQUIRY_QUESTIONNAIRE;

  /** 回答ステータス：アサイン */
  private ANSWER_ASSIGN = ANSWER_ASSIGN;

  /** 公開設定選択肢 */
  private INQUIRY_PUBLISHED = INQUIRY_PUBLISHED;

  /** 公開設定色分け */
  private INQUIRY_PUBLISHED_COLOR = INQUIRY_PUBLISHED_COLOR;
}
